export const InputMode = {
    Implicit: "Implicit",
    Parametric: "Parametric",
    SDF: "SDF",
};